import { render, staticRenderFns } from "./BansList.vue?vue&type=template&id=7ea48fcc&scoped=true&"
import script from "./BansList.vue?vue&type=script&lang=js&"
export * from "./BansList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea48fcc",
  null
  
)

export default component.exports